export default "__VITE_ASSET__tjw_ZGsN__"